import React from 'react'

import * as h2Api from '../../../h2Api'

class ProfileSectionIndeedJobListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jobs: [],
      loading: true
    }

    if (props.section.additional.retrievalUrl) {
      props
        .dispatch(
          h2Api.post(props.section.additional.retrievalUrl)({ type: 'INTERNAL_JOBS' })
        )
        .then(v => {
          console.log(v)
          this.setState({
            ...this.state,
            jobs: v,
            loading: false
          })
          console.log(this.state)
        })
    }
  }

  //add job log call
  logView(jo) {
    this.props
      .dispatch(
        h2Api.post(
          `/profiles/${this.props.profile.type}/${this.props.profile.id}/jobopenings/log`,
          {
            logString: jo.logString
          }
        )({ type: 'INTERNAL_JOBS_LOG' })
      )
      .then(v => {
        if (s.newWindow) {
          window.open(jo.url, '_blank')
        } else {
          window.location.href = jo.url
        }
      })
  }

  outputTable(section) {
    return section.map(s => (
      <tr className="list" key={s.url}>
        <td className="item">
          <a
            href={s.url}
            onClick={e => {
              e.preventDefault()
              console.log(e, s)
              this.logView(s)
            }}
            className="normal-listing"
            target={s.newWindow ? '_self' : '_blank'}
            rel="noreferrer">
            {s.title}
          </a>
        </td>
        <td className="item">{s.location}</td>
        <td className="item">{new Date(s.datePosted).toLocaleDateString('en-US')}</td>
      </tr>
    ))
  }

  render() {
    const section = this.state.jobs

    if (!section) {
      return null
    }

    return (
      <table className="table noround">
        <thead>
          <tr className="table-head">
            <th>Position</th>
            <th>Location</th>
            <th>Date Posted</th>
          </tr>
        </thead>
        <tbody>
          {this.state.loading ? (
            <tr>
              <td colSpan="3" className="text-center">
                <h3>Retrieving Jobs</h3>
              </td>
            </tr>
          ) : (
            this.outputTable(section)
          )}
        </tbody>
      </table>
    )
  }
}

export default ProfileSectionIndeedJobListing
